import { render } from "./SelectedProject.vue?vue&type=template&id=39914326&scoped=true"
import script from "./SelectedProject.vue?vue&type=script&lang=js"
export * from "./SelectedProject.vue?vue&type=script&lang=js"

import "./SelectedProject.vue?vue&type=style&index=0&id=39914326&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39914326"]])

export default __exports__